/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { convertPostConvertJson } from "../../funcs/convertPostConvertJson.js";
import { PostConvertJsonRequest$zodSchema } from "../../models/postconvertjsonop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostConvertJsonRequest$zodSchema,
};

export const tool$convertPostConvertJson: ToolDefinition<typeof args> = {
  name: "convert-post-convert-json",
  description: `JSON 格式化

还在为一团乱麻的 JSON 字符串头疼吗？这个接口能瞬间让它变得井井有条，赏心悦目。

## 功能概述
你只需要提供一个原始的、可能是压缩过的或者格式混乱的 JSON 字符串，这个 API 就会返回一个经过美化（带标准缩进和换行）的版本。这在调试 API 响应、或者需要在前端界面清晰展示 JSON 数据时非常有用。

## 使用须知
> [!NOTE]
> **请求格式**
> 请注意，待格式化的 JSON 字符串需要被包裹在另一个 JSON 对象中，作为 \`content\` 字段的值提交。具体格式请参考请求体示例。

## 错误处理指南
- **400 Bad Request**: 最常见的原因是你提供的 \`content\` 字符串本身不是一个有效的 JSON。请仔细检查括号、引号是否正确闭合，或者有没有多余的逗号等语法错误。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await convertPostConvertJson(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
